import { http } from '../axios';
import { libraryManagedConfig } from '../../config';

export type UpdateProductGroupSlotRequest = {
    active: boolean;
}

export type ApiUpdateProductGroupSlot = {
    slotId: number, body: UpdateProductGroupSlotRequest
}

export const updateProductGroupSlot = ({slotId, body}: ApiUpdateProductGroupSlot) => {
    return http.put<void>(libraryManagedConfig().endpointUpdateProductGroupSlot, body, {
        pathParams: { slotId }
    });
};
